module.exports = __webpack_public_path__ + "assets/img/401.edc14c32.png";